import { useState } from 'react'
import { Button } from 'components'
import { useSetToast } from 'hooks'
import { createMissingProductThemeOverrides } from 'api/admin'

export const ThemeToProductValidationButton = () => {
  const [loading, setLoading] = useState(false)
  const setToast = useSetToast()

  const launchThemes = async () => {
    if (loading) return
    setLoading(true)

    try {
      await createMissingProductThemeOverrides()

      setToast({
        icon: 'check',
        text: 'Theme to Product validation requested successfully',
      })
    } catch (error) {
      setToast({
        text:
          error instanceof Error && error.message === 'Request timed out'
            ? 'Operation timed out. Please try again later.'
            : 'Failed to validate themes to products',
      })
    } finally {
      setLoading(false)
    }
  }

  const buttonText = loading
    ? '🎨 Validating Theme to Product...'
    : '🎨 Validate Theme to Product relationship'

  return (
    <Button primary onClick={launchThemes}>
      {buttonText}
    </Button>
  )
}

export default ThemeToProductValidationButton
